import { render, staticRenderFns } from "./LinkWithPlugins.vue?vue&type=template&id=05d6fb4e&scoped=true&"
import script from "./LinkWithPlugins.vue?vue&type=script&lang=js&"
export * from "./LinkWithPlugins.vue?vue&type=script&lang=js&"
import style0 from "./LinkWithPlugins.vue?vue&type=style&index=0&id=05d6fb4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d6fb4e",
  null
  
)

export default component.exports